import React, { FC } from 'react'
// SwipeableDrawer was throwing: Element type is invalid, this seemed to fix it
// eslint-disable-next-line no-restricted-imports
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import styled, { useTheme } from 'styled-components'
import { CloseIcon } from './CloseIcon'

export interface SwipeableMenuContainerProps {
  isOpen: boolean
  toggleOpen: () => void
  backgroundColor?: string
  iconColor?: string
  showCloseIcon?: boolean
}

export const SwipeableMenuContainer: FC<React.PropsWithChildren<SwipeableMenuContainerProps>> = ({
  isOpen,
  toggleOpen,
  backgroundColor,
  iconColor,
  children,
  showCloseIcon = true,
}) => {
  const theme = useTheme()
  const paperProps = { style: { backgroundColor: backgroundColor || theme.colors.background.dark } }
  return (
    <SwipeableDrawer slotProps={{ docked: paperProps }} open={isOpen} onClose={toggleOpen} onOpen={toggleOpen}>
      <Container backgroundColor={backgroundColor}>
        {showCloseIcon && (
          <PositionAbsolute>
            <CloseIcon onClick={toggleOpen} color={iconColor || theme.colors.white} />
          </PositionAbsolute>
        )}
        {children}
      </Container>
    </SwipeableDrawer>
  )
}

interface ContainerProps {
  backgroundColor?: string
}

const Container = styled.div<ContainerProps>`
  width: 90vw;
  height: 100%;
  background-color: ${({ theme, backgroundColor }) => backgroundColor || theme.colors.background.dark};
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.white};
  position: relative;
  padding-top: 1.6rem;
`

const PositionAbsolute = styled.div`
  position: absolute;
  top: 2rem;
  right: 2rem;
`
